export const SUBSCRIPTION_REFRESH_KEY = 'optimise.subscriptionRefreshRequestedAt';
